import React, { useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import "../../styles/login.css";
import { verificationOTPForUserVerify } from "../../login/actions/loginAction";
import loginLabel from "../labels/login_en.json";

const VerifyUser = (props) => {
  const { register, formState, errors, watch, setError } = useForm({
    mode: "onChange",
  });

  const dispatch = useDispatch();

  const verifyuser = useSelector(
    (state) => state.loginReducer.verify_user,
    shallowEqual
  );
  const { flg_verify_show } = useSelector(
    (state) => state.loginReducer,
    shallowEqual
  );

  const { email_otp_flag, mobile_otp_flag } = useSelector(
    (state) => state.loginReducer,
    shallowEqual
  );

  useEffect(() => {
    if (flg_verify_show === false) {
      props.history.push("/admin/login");
    }
  }, [flg_verify_show]);

  const verifyUserOtpResponse = verifyuser.otpResponseDto;
  const verificationEmailOTP = (type) => {
    let otpid;
    let otptype;

    verifyUserOtpResponse.map((ele, key) => {
      if (ele.type === type) {
        otpid = ele.id;
        otptype = ele.type;
      }
      return true;
    });
    if (watch("OTP_email") || watch("OTP_mobile")) {
      let reqBody = {
        username: verifyuser.username,
        otpId: otpid,
        otpType: otptype,
        enteredOtp: watch("OTP_email"),
      };

      dispatch(verificationOTPForUserVerify(reqBody));
    } else {
      setError("OTP_email", { type: "required" });
    }
  };

  const verificationMobileOTP = (type) => {
    let otpid;
    let otptype;

    verifyUserOtpResponse.map((ele, key) => {
      if (ele.type === type) {
        otpid = ele.id;
        otptype = ele.type;
      }
      return true;
    });
    if (watch("OTP_mobile") || watch("OTP_email")) {
      let reqBody = {
        username: verifyuser.username,
        otpId: otpid,
        otpType: otptype,
        enteredOtp: watch("OTP_mobile"),
      };

      dispatch(verificationOTPForUserVerify(reqBody));
    } else {
      setError("OTP_mobile", { type: "required" });
    }
  };

  const handleClick = () => {
    props.history.push("/admin/login");
  };

  return (
    <div>
      <form>
        <div className="row d-flex mt-20">
          <div className="col-md-4"></div>
          <div className="form-group col-md-4 bgColor-fff">
            <div className="text-center">
              <span className="bold-text">
                {loginLabel.Email_Mobile_OTP_verification}
              </span>
            </div>
            {verifyuser.isEmailVerified === false ? (
              <div className="form-group">
                <label className="LeftText">
                  {loginLabel.ENTER_EMAIL_OTP}{" "}
                  <span className="color-red">*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength={6}
                    name="OTP_email"
                    ref={register({ required: false })}
                    aria-label="emailotp"
                    aria-describedby="button-addon2"
                    disabled={email_otp_flag}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-secondary font-12"
                      type="button"
                      id="button-addon2"
                      onClick={() => {
                        verificationEmailOTP("email");
                      }}
                      disabled={email_otp_flag}
                    >
                      {loginLabel.VERIFY_OTP}
                    </button>
                  </div>
                </div>
                {_.get("OTP_email.type", errors) === "required" && (
                  <p className="errorText">{loginLabel.Email_OTP_Required}</p>
                )}
              </div>
            ) : (
              ""
            )}
            {verifyuser.isMobileVerified === false ? (
              <div className="form-group">
                <label className="LeftText">
                  {" "}
                  {loginLabel.Enter_Mobile_OTP}
                  <span className="color-red">*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength={6}
                    name="OTP_mobile"
                    ref={register({ required: false })}
                    aria-label="mobileotp"
                    aria-describedby="button-addon2"
                    disabled={mobile_otp_flag}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-secondary font-12"
                      type="button"
                      id="button-addon2"
                      onClick={() => {
                        verificationMobileOTP("mobile");
                      }}
                      disabled={mobile_otp_flag}
                    >
                      {loginLabel.VERIFY_OTP}
                    </button>
                  </div>
                </div>
                {_.get("OTP_mobile.type", errors) === "required" && (
                  <p className="errorText">Mobile OTP is required</p>
                )}
              </div>
            ) : (
              ""
            )}
            <div className="d-flex justify-content-center mb-3 mt-4">
              <button
                type="button"
                disabled={!formState.isValid}
                className="btn btn-primary"
                onClick={handleClick}
              >
                {loginLabel.back_to_login}
              </button>
            </div>
          </div>
          <div className="col-md-4"></div>
        </div>
      </form>
    </div>
  );
};

export default VerifyUser;
